import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { landingPath } from "./permission";

const AccessDenied = () => {
  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("authUser");
    window.location.href = "/login";
  };
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 text-center px-6">
      <h1 className="text-2xl font-bold">Access denied</h1>
      <p className="text-gray-600">Your account has no permission for this application. Please contact an administrator.</p>
      <button className="px-4 py-2 bg-red-600 text-white rounded" onClick={logout}>
        Logout
      </button>
    </div>
  );
};

// Gate a route by (1) authentication and (2) the caller's kirtan-module permission.
// `check` is a predicate from Utils/permission (e.g. canRead / canCreate / canUpdate).
export const ProtectedRoute = ({ children, check }) => {
  const token = sessionStorage.getItem("token");
  const { loaded, kirtan } = useSelector((state) => state.permission);

  if (!token) return <Navigate to="/login" replace />;

  // Permission is fetched on app load / after login. Wait until it resolves.
  if (!loaded) {
    return <div className="flex items-center justify-center h-screen">Loading…</div>;
  }

  if (check && !check(kirtan)) {
    const target = landingPath(kirtan);
    if (!target) return <AccessDenied />;
    return <Navigate to={target} replace />;
  }

  return children;
};
